export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_05_blank.f18e8e12.png";